import { Stack, Typography } from "@mui/material";
import styled from "styled-components";

interface SectionProps {
  children: React.ReactNode;
  title?: string;
}

export const Section: React.FC<SectionProps> = ({ children, title }) => {
  return (
    <Stack spacing={3} mb={2}>
      {title && <Typography variant="subtitle2">{title}</Typography>}
      {children}
      <Divider />
    </Stack>
  );
};

const Divider = styled.div`
  height: 1px;
  background-color: ${({ theme }) => theme.colors.redesign.db10};
`;
